import { useContext } from 'react';
import {
  IRewardsAndOffersProviderValues,
  RewardsAndOffersContext,
} from '../contexts/api/rewardsAndOffers-context';

/**
 * Hook to access rewards and offers context data
 * Provides rewardsAndOffers and generalError from context
 */
export const useRewardsAndOffers = (): IRewardsAndOffersProviderValues => {
  const context = useContext(RewardsAndOffersContext);
  if (!context) {
    throw new Error(
      'useRewardsAndOffers must be used within a RewardsAndOffersProvider',
    );
  }
  return context;
};
